<form class="tabbed-dialog-layout" [formGroup]="assignmentSettingsForm" (ngSubmit)="updateAssignmentSettingsData()">
  <section class="tabbed-dialog-body">
    <h4>Uppgifter som föreslås till uppdragsavtalet</h4>
    <span>På uppdragsavtal tillämpar byrån de allmänna villkoren från:</span>
    <div class="flex flex-row items-center mb-4">
      <div class="relative flex items-center w-1/2 mr-6">
        <bl-frontend-checkbox
          (checkedChange)="onSrfOrFarToggle($event, 'srf')"
          formControlName="use_srf"
          id="srf"></bl-frontend-checkbox>
        <bl-frontend-text-input class="w-full" formControlName="srf_text" />
      </div>
      <div class="relative flex items-center w-1/2">
        <bl-frontend-checkbox
          (checkedChange)="onSrfOrFarToggle($event, 'far')"
          formControlName="use_far"
          id="far"></bl-frontend-checkbox
        ><bl-frontend-text-input class="w-full" formControlName="far_text" />
      </div>
    </div>
    <div class="w-1/2 pr-3">
      <div class="flex flex-col mb-4">
        <label class="leading-tight text-bl-grey" for="notice">Uppsägningstid</label>
        <bl-frontend-text-input id="notice" formControlName="notice_period" />
      </div>
    </div>
    <div class="flex flex-row w-full mb-4">
      <div class="flex flex-col w-1/2 mr-6">
        <label class="leading-tight text-bl-grey" for="records-delivery">Materialleverans</label>
        <bl-frontend-text-input formControlName="material_delivery1" />
        <bl-frontend-text-input formControlName="material_delivery2" />
        <bl-frontend-text-input formControlName="material_delivery3" />
        <bl-frontend-text-input formControlName="material_delivery4" />
      </div>
      <div class="flex flex-col w-1/2">
        <label class="leading-tight text-bl-grey">Betalningsvillkor</label>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_payment_condition_text1"
            formControlName="show_payment_condition_text1"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_condition_text1" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_payment_condition_text2"
            formControlName="show_payment_condition_text2"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_condition_text2" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_payment_condition_text3"
            formControlName="show_payment_condition_text3"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_condition_text3" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_payment_condition_text4"
            formControlName="show_payment_condition_text4"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_condition_text4" />
        </div>
      </div>
    </div>
    <div class="flex flex-row w-full mb-4">
      <div class="flex flex-col w-1/2 mr-4">
        <label class="leading-tight text-bl-grey" for="pricing">Ersättning</label>
        <div class="relative flex items-center">
          <bl-frontend-checkbox id="show_payment_text1" formControlName="show_payment_text1"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_text1" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox id="show_payment_text2" formControlName="show_payment_text2"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_text2" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox id="show_payment_text3" formControlName="show_payment_text3"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_text3" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox id="show_payment_text4" formControlName="show_payment_text4"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="payment_text4" />
        </div>
      </div>
      <div class="flex flex-col w-1/2">
        <label class="leading-tight text-bl-grey">Bilagor</label>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_attachment_text1"
            formControlName="show_attachment_text1"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="attachment_text1" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_attachment_text2"
            formControlName="show_attachment_text2"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="attachment_text2" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_attachment_text3"
            formControlName="show_attachment_text3"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="attachment_text3" />
        </div>
        <div class="relative flex items-center">
          <bl-frontend-checkbox
            id="show_attachment_text4"
            formControlName="show_attachment_text4"></bl-frontend-checkbox>
          <bl-frontend-text-input class="w-full" formControlName="attachment_text4" />
        </div>
      </div>
    </div>
    <div class="mb-4 grid gap-4 grid-flow-col grid-cols-2">
      <div class="flex flex-col mt-2">
        <label class="leading-tight text-bl-grey" for="other_condition_text">Övriga uppgifter</label>
        <bl-frontend-textarea
          [maxLength]="maxLength"
          [maxLengthText]="' / ' + maxLength + ' tecken'"
          id="other_condition_text"
          formControlName="other_condition_text"
          [rows]="6"></bl-frontend-textarea>
      </div>
      <div class="flex flex-col mt-2">
        <label class="leading-tight text-bl-grey" for="other_terms_text">Övriga villkor</label>
        <bl-frontend-textarea
          [maxLength]="maxLength"
          [maxLengthText]="' / ' + maxLength + ' tecken'"
          id="other_terms_text"
          formControlName="other_terms_text"
          [rows]="6"></bl-frontend-textarea>
      </div>
    </div>
    <fieldset class="mt-6" [formGroup]="userFirmDetailsForm" [disabled]="savingUserFirmDetails()">
      <legend class="text-lg font-semibold">Egna byråuppgifter</legend>
      <p *ngIf="loadingUserFirmDetails()" role="status">Hämtar dina egna byråuppgifter...</p>
      <p *ngIf="userFirmDetailsError()" role="alert">{{ userFirmDetailsError() }}</p>
      <bl-frontend-button
        *ngIf="!loadingUserFirmDetails() && !userFirmDetailsLoaded()"
        variant="secondary"
        text="Försök hämta igen"
        (onclick)="loadUserFirmDetails()"></bl-frontend-button>
      <ng-container *ngIf="userFirmDetailsLoaded()">
        <bl-frontend-checkbox
          id="use_user_firm_details"
          formControlName="enabled"
          text="Använd egna byråuppgifter på användarnivå"></bl-frontend-checkbox>
        <p class="mt-2 text-bl-grey">
          Uppgifterna gäller bara dig och ändrar inte byråns gemensamma uppgifter. Om du avmarkerar och sparar tas dina
          egna uppgifter bort.
        </p>
        <div
          *ngIf="userFirmDetailsForm.controls.enabled.value"
          formGroupName="details"
          class="mt-4 flex flex-col gap-3 w-full md:w-1/2">
          <bl-frontend-text-input
            id="assignment_name"
            name="assignment_name"
            text="Byrånamn"
            formControlName="name"
            placeholder="Ange byrånamn"></bl-frontend-text-input>
          <bl-frontend-text-input
            id="assignment_corporateIdentity"
            name="assignment_corporateIdentity"
            text="Organisationsnummer"
            formControlName="corporateIdentity"
            placeholder="Ange organisationsnummer"></bl-frontend-text-input>
          <bl-frontend-text-input
            id="assignment_address"
            name="assignment_address"
            text="Adress"
            formControlName="address"
            placeholder="Ange adress"></bl-frontend-text-input>
          <div class="flex gap-2">
            <bl-frontend-text-input
              class="w-1/4"
              id="assignment_zipcode"
              name="assignment_zipcode"
              text="Postnummer"
              formControlName="zipcode"
              placeholder="Ange postnummer"></bl-frontend-text-input>
            <bl-frontend-text-input
              class="w-3/4"
              id="assignment_city"
              name="assignment_city"
              text="Ort"
              formControlName="city"
              placeholder="Ange ort"></bl-frontend-text-input>
          </div>
          <bl-frontend-text-input
            id="assignment_phone"
            name="assignment_phone"
            text="Telefon"
            formControlName="phone"
            placeholder="Ange telefonnummer"></bl-frontend-text-input>
          <bl-frontend-text-input
            id="assignment_email"
            name="assignment_email"
            text="E-post"
            formControlName="email"
            placeholder="Ange e-postadress"></bl-frontend-text-input>
          <p
            *ngIf="
              userFirmDetailsForm.controls.details.controls.email.invalid &&
              userFirmDetailsForm.controls.details.controls.email.touched
            "
            role="alert">
            Ange en giltig e-postadress.
          </p>
        </div>
      </ng-container>
    </fieldset>
  </section>
  <div class="tabbed-dialog-actions flex flex-row justify-between p-4 bg-bl-grey-100">
    <bl-frontend-button
      (onclick)="resetDialog = !resetDialog"
      [disabled]="savingUserFirmDetails()"
      variant="secondary-negative"
      text="Återställ texter"></bl-frontend-button>
    <bl-frontend-button
      type="submit"
      class="ml-2"
      [disabled]="!canSaveUserFirmDetails"
      text="Spara"></bl-frontend-button>
  </div>
</form>

<p-dialog header="Bekräfta återställning" [(visible)]="resetDialog" [draggable]="false">
  <p>
    Dina textändringar och kryssval till uppdragsavtalet kommer att tas bort och återställas till Workflows
    grundförslag.
  </p>
  <p>Dina egna byråuppgifter påverkas inte.</p>
  <p-footer>
    <bl-frontend-button (onclick)="resetDialog = !resetDialog" variant="secondary" text="Avbryt"></bl-frontend-button>
    <bl-frontend-button (onclick)="resetAssignmentSettings()" text="Okej, återställ"></bl-frontend-button>
  </p-footer>
</p-dialog>
